(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  let scheduled = false;

  const positionEventDate = () => {
    scheduled = false;

    if (!desktop.matches) return;

    const eventDate = document.querySelector('#main-cart-footer cart-note');
    const quantityCell = document.querySelector('cart-items .cart-item__quantity');

    if (!eventDate || !quantityCell) return;

    eventDate.classList.add('custom-cart-event-date');

    const field = eventDate.querySelector('#Cart-note');
    if (field) {
      field.rows = 1;
      field.placeholder = 'MM/DD/YYYY';
      field.setCustomValidity('');

      if (!field.dataset.customEventDateReady) {
        field.dataset.customEventDateReady = 'true';
        field.addEventListener('change', (event) => {
          event.stopPropagation();
          field.setCustomValidity('');
        });
      }
    }

    quantityCell.append(eventDate);
  };

  const schedulePosition = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(positionEventDate);
  };

  schedulePosition();
  document.addEventListener('DOMContentLoaded', schedulePosition, { once: true });
  new MutationObserver(schedulePosition).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
